import { RespinIndex } from "../../config/GlobalVariableConfig";
import { REEL_NUMBERS, SYMBOLS_PER_REEL } from "../../config/reelConfig";
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { DisplayComponent } from "../../core/displays/DisplayComponent";
import { getJackpotEntryByValue, wait } from "../../core/utils";
import { SequentialTask } from "../../core/utils/SequentialTask";
import { GameConstants } from "../../gameClientEvents/GameConstants";
import { IFeatureData, RespinObject, spinData } from "../../server/getServerResposesFun";
import { MeterComponent } from "../meter/MeterComponent";
import { ReelComponent } from "../reels/ReelsComponent";
import { TrailsComponent } from "../trail/TrailsComponent";

export class ScarabWinsComponent extends AbstractDisplayComponent {
    private featureData: IFeatureData;

    public startWinFeature(respinIndex: number, callback?: () => void): Promise<any> {
        const data: RespinObject = spinData.respins[respinIndex];
        this.featureData = data?.featureData;

        if (!this.featureData) {
            console.warn("No featureData found at index", RespinIndex.value);
            callback?.();
            return Promise.resolve();
        }

        let seq = new SequentialTask([
            () => this.animateSymbols(),
            () => this.showMeterHighlight(),
            () => wait(500),
            () => {
                callback?.();
                return Promise.resolve();
            }
        ]);
        return seq.execute();
    }

    public startCollectFeature(respinIndex: number, callback?: () => void): Promise<any> {
        const data: RespinObject = spinData.respins[respinIndex];
        this.featureData = data?.featureData;

        if (!this.featureData) {
            console.warn("No featureData found at index", RespinIndex.value);
            callback?.();
            return Promise.resolve();
        }

        let seq = new SequentialTask([
            () => this.animateReelScarabSymbols(),
            () => wait(500),
            () => {
                callback?.();
                return Promise.resolve();
            }
        ]);
        return seq.execute();
    }

    private animateSymbols() {
        let scarabWinPos = this.featureData.scarabWinData?.winSymbolPosistions;
        for (let i = 0; i < scarabWinPos.length; i++) {
            const sym = DisplayComponent.get(ReelComponent).getInstance().reelSymbols[scarabWinPos[i][0]][scarabWinPos[i][1]];
            sym.state.setAnimation(0, "win", false);
            //let scarabWin = this.featureData.scarabWinData?.winAmount;
            let jp = getJackpotEntryByValue(scarabWinPos.length);
            DisplayComponent.get(TrailsComponent).triggerTrail(sym, DisplayComponent.get(MeterComponent).getCurrentBaseGameActiveMeter(jp.index), () => {
                //sym.state.setAnimation(0, "idle", true);
            });
        }
    }

    //@ts-ignore
    private showMeterHighlight() {
        let scarabWin = this.featureData.scarabWinData?.winAmount;
        let scarabWinPos = this.featureData.scarabWinData?.winSymbolPosistions;
        if (scarabWin > 0) {
            let jp = getJackpotEntryByValue(scarabWinPos.length);
            if (jp) {
                return new Promise<void>((resolve) => {
                    DisplayComponent.get(MeterComponent).highlight(jp.index, resolve);
                });
            }
        }

        return Promise.resolve();
    }

    private animateReelScarabSymbols() {
        return new Promise<void>((resolve) => {
            let trailCount = 0;
            let completedTrailHits = 0;
            let hasUpdatedMeterText = false;

            const onTrailHit = () => {
                completedTrailHits++;
                if (!hasUpdatedMeterText) {
                    hasUpdatedMeterText = true;
                    this.updateMeterText();
                }
                if (completedTrailHits >= trailCount) {
                    resolve();
                }
            };

            for (let i = 0; i < REEL_NUMBERS; i++) {
                for (let j = 0; j < SYMBOLS_PER_REEL; j++) {
                    const sym = DisplayComponent.get(ReelComponent).getInstance().reelSymbols[i][j];
                    const reelObj = DisplayComponent.get(ReelComponent).getInstance().allReelArray[i];
                    const symbolId = reelObj.symbols[j].id;
                    if (symbolId === GameConstants.SPECIAL_SYMBOL_ID) {
                        trailCount++;
                        sym.state.setAnimation(0, "win", false);
                        DisplayComponent.get(TrailsComponent).triggerTrail(sym, DisplayComponent.get(MeterComponent).getCurrentActiveMeter(), () => {
                            onTrailHit();
                        });
                    }
                }
            }

            if (trailCount === 0) {
                resolve();
            }
        });
    }

    private updateMeterText() {
        let scarabCollected = this.featureData.scarabCollectData?.collected;
        let scarabRemaining = this.featureData.scarabCollectData?.remaining;
        if (scarabCollected > 0) {
            DisplayComponent.get(MeterComponent).updateMeterText(scarabCollected, scarabRemaining);
        }
        return Promise.resolve();
    }

    public getInstance(): any {
        return null;
    }
}
